import React from "react";
import './MatchCard.css';
import {type MatchDisplay, type MatchPlayer} from '@iziping/common';
import {haveSameClub} from '@iziping/common';

interface MatchCardProps {
    match: MatchDisplay
}

const MatchCard: React.FC<MatchCardProps> = ({match}) => {
    const sameClub = haveSameClub(match);

    return (
        <div className="match-card">
            <div
                className={`match-card-title ${sameClub ? "match-pending" : "match-finished"}`}>
            </div>
            <div className={'match-content'}></div>
            {match.opponents.map((opponent: MatchPlayer) => (
                <span className={'match-player'}>{opponent.ranking}. {opponent.name} ({opponent.club})</span>
            ))}
        </div>
    );
};

export default MatchCard;